"use strict";
/**
 * Created by Ning Jiang on 1/5/2017.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextBetLineNumber = void 0;
const BetLineNumber_1 = require("../../../core/betline/BetLineNumber");
const GameConfig_1 = require("../../../core/gameconfig/GameConfig");
const StageManager_1 = require("../../../core/stage/StageManager");
const gsap_1 = require("gsap");
const MathHelper_1 = require("../../../core/utils/MathHelper");
class TextBetLineNumber extends BetLineNumber_1.BetLineNumber {
    constructor(index, config) {
        super(index, config);
        this._config = config;
        if ((0, MathHelper_1.isNumber)(this._config.horizontalPadding)) {
            this._horizontalPadding = [this._config.horizontalPadding, this._config.horizontalPadding];
        }
        else {
            this._horizontalPadding = this._config.horizontalPadding;
        }
        if ((0, MathHelper_1.isNumber)(this._config.verticalPadding)) {
            this._verticalPadding = [this._config.verticalPadding, this._config.verticalPadding];
        }
        else {
            this._verticalPadding = this._config.verticalPadding;
        }
    }
    draw(config) {
        this.addChild(this.createBackground(config.width, config.height));
        this._normalText = new PIXI.Text(this.index.toString(), config.textStyleNormal);
        this._normalText.anchor.set(0.5, 0.5);
        this.addChild(this._normalText);
        this._winText = new PIXI.Text(this.index.toString(), config.textStyleWin);
        this._winText.anchor.set(0.5, 0.5);
        this._winText.alpha = 0;
        this.addChild(this._winText);
        StageManager_1.StageManager.getLayer(config.layer).addChild(this);
    }
    createBackground(width, height) {
        const background = new PIXI.Graphics();
        background.beginFill(0x000000, 0);
        background.drawRect(0, 0, width, height);
        background.endFill();
        return background;
    }
    showMouseOver() {
        this.killAllTweens();
        this._normalTextAlphaTween = gsap_1.TweenLite.to(this._normalText, 0.1, { alpha: 0 });
        this._winTextAlphaTween = gsap_1.TweenLite.to(this._winText, 0.1, { alpha: 1 });
    }
    showMouseOut() {
        this.killAllTweens();
        this._normalTextAlphaTween = gsap_1.TweenLite.to(this._normalText, 0.1, { alpha: 1 });
        this._winTextAlphaTween = gsap_1.TweenLite.to(this._winText, 0.1, { alpha: 0 });
    }
    showWin() {
        this.killAllTweens();
        this._normalTextAlphaTween = gsap_1.TweenLite.to(this._normalText, 0.1, { alpha: 0 });
        this._winTextAlphaTween = gsap_1.TweenLite.to(this._winText, 0.1, { alpha: 1 });
        this._normalTextScaleTween = gsap_1.TweenLite.to(this._normalText.scale, 0.17, {
            x: this._config.textWinScale,
            y: this._config.textWinScale
        });
        this._winTextScaleTween = gsap_1.TweenLite.to(this._winText.scale, 0.17, {
            x: this._config.textWinScale,
            y: this._config.textWinScale
        });
    }
    showNormal() {
        this.killAllTweens();
        this._normalTextAlphaTween = gsap_1.TweenLite.to(this._normalText, 0.33, { alpha: 1 });
        this._winTextAlphaTween = gsap_1.TweenLite.to(this._winText, 0.33, { alpha: 0 });
        this._normalTextScaleTween = gsap_1.TweenLite.to(this._normalText.scale, 0.33, { x: 1, y: 1 });
        this._winTextScaleTween = gsap_1.TweenLite.to(this._winText.scale, 0.33, { x: 1, y: 1 });
    }
    killAllTweens() {
        if (this._normalTextAlphaTween && this._normalTextAlphaTween.isActive()) {
            this._normalTextAlphaTween.pause();
            this._normalTextAlphaTween.kill();
        }
        if (this._normalTextScaleTween && this._normalTextScaleTween.isActive()) {
            this._normalTextScaleTween.pause();
            this._normalTextScaleTween.kill();
        }
        if (this._winTextAlphaTween && this._winTextAlphaTween.isActive()) {
            this._winTextAlphaTween.pause();
            this._winTextAlphaTween.kill();
        }
        if (this._winTextScaleTween && this._winTextScaleTween.isActive()) {
            this._winTextScaleTween.pause();
            this._winTextScaleTween.kill();
        }
    }
    // Hardcoded default even number betLines. positionIndex starts from 0.
    setPosition(betLinesNum, positionIndex) {
        const stageWidth = GameConfig_1.GameConfig.instance.GAME_WIDTH;
        const stageHeight = GameConfig_1.GameConfig.instance.GAME_HEIGHT;
        const numLineInOneSide = betLinesNum / 2;
        const numberLeftPositionX = this._horizontalPadding[0];
        const numberRightPositionX = stageWidth - this._horizontalPadding[1];
        const numberVerticalSpace = (stageHeight - this._verticalPadding[0] - this._verticalPadding[1]) / (numLineInOneSide - 1);
        const side = Math.floor(positionIndex / numLineInOneSide);
        const x = side === 0 ? numberLeftPositionX : numberRightPositionX;
        const y = Math.round(positionIndex % numLineInOneSide * numberVerticalSpace + this._verticalPadding[0]);
        this.x = x;
        this.y = y;
        return [x, y, side];
    }
}
exports.TextBetLineNumber = TextBetLineNumber;
//# sourceMappingURL=TextBetLineNumber.js.map